import { useEffect, useState } from 'react';
import { useUser } from '../components/providers/UserProvider';
import { useToast } from './useToast';
import { track } from '../analytics';

export function useReferral() {
  const { user, updateUser } = useUser();
  const { show } = useToast();
  const [referralSource, setReferralSource] = useState<string | null>(null);
  const [processed, setProcessed] = useState(false);

  useEffect(() => {
    if (processed || !user) return;

    const urlParams = new URLSearchParams(window.location.search);
    const sharedBy = urlParams.get('shared_by') || urlParams.get('ref');
    const utmSource   = urlParams.get('utm_source');
    const utmMedium   = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    const utmContent  = urlParams.get('utm_content');

    // Track UTM attribution even without a referral
    if (utmSource) {
      track('utm_attributed', {
        utm_source:   utmSource,
        utm_medium:   utmMedium || undefined,
        utm_campaign: utmCampaign || undefined,
        utm_content:  utmContent || undefined,
        referred_by:  sharedBy || undefined,
      });
    }

    if (sharedBy && !user.referredBy) {
      setReferralSource(sharedBy);

      // Store referral and award bonus XP
      updateUser({
        referredBy: sharedBy,
        experience: (user.experience || 0) + 25,
      });

      show('Welcome! You got 25 bonus XP from a referral 🎉', 'success');

      // Clean URL to avoid re-processing on refresh
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    } else if (utmSource) {
      // Clean UTM params after capturing them
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    }

    setProcessed(true);
  }, [processed, user, updateUser, show]);

  return { referralSource };
}
